import Vue from "vue";

import {
  Button,
  Table,
  Layout,
  Submenu,
  Menu,
  MenuItem,
  Content,
  Breadcrumb,
  BreadcrumbItem,
  Card,
  Icon,
  Row,
  Col,
  Divider,
  Drawer,
  Checkbox,
  Tabs,
  TabPane,
  Carousel,
  CarouselItem,
  Sider,
  Modal,
  BackTop,
  Select,
  Option,
  Page,
  Steps,
  Step,
  Message,
  FormItem,
  Form,
  Input,
  Spin,
  Scroll,
  Upload,
  Progress,
  RadioGroup,
  Radio,
  Switch
} from 'view-design'

const components = {
  Button,
  Table,
  Layout,
  Submenu,
  Menu,
  MenuItem,
  Content,
  Breadcrumb,
  BreadcrumbItem,
  Card,
  Icon,
  Row,
  Col,
  Divider,
  Drawer,
  Checkbox,
  Tabs,
  TabPane,
  Carousel,
  CarouselItem,
  Sider,
  Modal,
  BackTop,
  Select,
  Option,
  Page,
  Steps,
  Step,
  Message,
  FormItem,
  Form,
  Input,
  Spin,
  Scroll,
  Upload,
  Progress,
  RadioGroup,
  Radio,
  vSwitch:Switch
}

const componentsHandler = {
  install(Vue){
    Object.keys(components).forEach(key => { Vue.component(`${key}`, components[key]) })
  }
}

Vue.prototype.$Modal = Modal
Vue.prototype.$Message = Message

export default componentsHandler
